import { render, staticRenderFns } from "./openVipList.vue?vue&type=template&id=7b2ba7c0&scoped=true"
import script from "./openVipList.vue?vue&type=script&lang=js"
export * from "./openVipList.vue?vue&type=script&lang=js"
import style0 from "./openVipList.vue?vue&type=style&index=0&id=7b2ba7c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2ba7c0",
  null
  
)

export default component.exports